<template lang="pug">
  div(data-testid="card-tab-overall-memo")
    a.pull-right(v-if="editable" href="#" @click.prevent="openModal" data-testid="-link-edit") 編集
    h5 共有メモ

    memo-view(v-model="memo", :class="{'bcard-field-editted': isFieldEditted}" data-testid="-memo")

    portal(to="modal")
      app-modal(type="default" v-model="modalEdit.isOpen", data-testid="bcard-person-memo-modal")
        template(slot="title") 共有メモの変更
        memo-form(v-model="modalEdit.value")
        template(slot="footer" slot-scope="{close}")
          button.btn.btn-primary(type="button" @click.prevent="submit", data-testid="-btn-edit") 変更
          button.btn.btn-default(type="button" @click.prevent="close") キャンセル

      app-modal(v-model="modalError.isOpen" type="warning")
        template(slot="title") エラー
        h4 共有メモの変更に失敗しました。
        p(v-if="modalError.message") {{modalError.message}}
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import MemoView from '@/components/molecules/MemoView'
import MemoForm from '@/components/organisms/forms/MemoForm'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')

export default {
  name: 'CardTabOverallMemo',
  components: { AppModal, MemoView, MemoForm },
  props: {
    /**
     * @var sid_person
     */
    value: { type: [String, Number], required: false, default: '' },
    editable: { type: Boolean, required: true }
  },
  data () {
    return {
      memo: '---',
      isFieldEditted: false,
      modalEdit: {
        isOpen: false,
        value: ''
      },
      modalError: {
        isOpen: false,
        message: ''
      }
    }
  },
  watch: {
    value (id) {
      if (id) {
        this.getData(id)
      }
    }
  },
  created () {
    if (this.value) {
      this.getData(this.value)
    }
  },
  methods: {
    getData (id) {
      const vm = this
      PersonRepository.getMemo(id, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.memo = data.memo
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '共有メモが取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
          // vm.setErrorMessage(error)
        })
    },
    openModal () {
      this.modalEdit.value = this.memo
      this.modalEdit.isOpen = true
    },
    submit () {
      const vm = this
      const id = this.value
      const memo = this.modalEdit.value
      this.isFieldEditted = false
      PersonRepository.putMemo(id, memo, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.memo = vm.modalEdit.value
            vm.showToast('共有メモを変更しました。', { type: 'success' })
            vm.modalEdit.isOpen = false
            vm.isFieldEditted = true
          }
        })
        .catch(function (error) {
          vm.modalError.message = error.message
          vm.modalError.isOpen = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabOverallMemo.vue